import Navbar from './components/navbar/Navbar';
import Home from './components/home/Home';
import Footer from './components/footer/Footer';
import Details from './components/details/Details';
import Contact from './components/contact/Contact';
// import Updates from './components/updates/Updates';
import Services from './components/services/Services';
import About from './components/about/About';
import WorkForBrands from './components/work-for-brands/WorkForBrands';
import NotFound from './components/not-found/NotFound';
// import PreviewDebugger from './components/preview-debugger/PreviewDebugger';
// import CrossDomainPreview from './components/preview-debugger/CrossDomainPreview';
import { Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useLayoutEffect, useState } from 'react';
import { fetchAuth } from './utils/auth';
import "./App.css";
import MetaTagsManager from './components/meta-tags-manager/MetaTagsManager';
import { ThemeProvider } from './theme/theme-provider';
import ServiceStatusBanner from './components/service-status/ServiceStatusBanner';


const updateStaticMetaTags = (route) => {
  // Extract route information
  const isDetailsPage = route.pathname.startsWith('/release/');
  const slug = isDetailsPage ? route.pathname.split('/release/')[1] : null;
  
  // Get the base domain for API
  const apiUrl = process.env.REACT_APP_API_URL;
  
  // Set different meta tags based on route
  if (isDetailsPage && slug) {
    // Get song ID from slug if possible
    let songId = slug;
    // console.log(`APP.js Updating meta tags for details page with slug: ${slug}`);
    if (slug.includes('-')) {
      const parts = slug.split('-');
      const lastPart = parts[parts.length - 1];

      // console.log(`Extracted last part from slug: ${lastPart}`);
      if (/^\d+$/.test(lastPart)) {
        songId = lastPart;
      }
    }
    
    // Use public-preview for static meta tags for details pages
    document.querySelector('meta[property="og:title"]').setAttribute('content', `Distorise Music - ${slug.replace(/-/g, ' ')}`);
    document.querySelector('meta[property="og:description"]').setAttribute('content', 'Listen to this track on Distorise Music');
    document.querySelector('meta[property="og:image"]').setAttribute('content', `${apiUrl}/public-preview/${songId}.jpg?v=${Date.now()}`);
    document.querySelector('meta[property="og:type"]').setAttribute('content', 'music.song');
  } else {
    // Default meta tags for home and other pages
    document.querySelector('meta[property="og:title"]').setAttribute('content', 'Distorise Music');
    document.querySelector('meta[property="og:description"]').setAttribute('content', 'Discover and enjoy unique music tracks on Distorise Music');
    document.querySelector('meta[property="og:image"]').setAttribute('content', `${apiUrl}/default-preview.jpg?v=${Date.now()}`);
    document.querySelector('meta[property="og:type"]').setAttribute('content', 'website');
  }
  
  // Add url meta tag
  document.querySelector('meta[property="og:url"]').setAttribute('content', window.location.href);
}


const App = () => {
    const [page, setPage] = useState("")
    const [token, setToken] = useState(null)
    const location = useLocation();

    const sendPage = (page) => {
      setPage(page);
    }

    useEffect(() => {
      // Update meta tags on route change - this runs BEFORE component renders
      updateStaticMetaTags(location);
    }, [location.pathname]);

    useEffect(() => {
      if (!location.hash) {
        return;
      }

      const targetId = location.hash.replace('#', '');
      const scrollToHashTarget = () => {
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };

      requestAnimationFrame(scrollToHashTarget);
    }, [location.pathname, location.hash]);

    useLayoutEffect(() => {

        // Fetch new token if none exists
        if (!token) {
            fetchAuth();
        }

        setToken(localStorage.getItem("token"))

        return () => {
            // Cleanup interceptor if needed
        };
    }, [])

    return (
      <ThemeProvider>
      <Navbar page={page} />        
        <ServiceStatusBanner />
        <MetaTagsManager />
        <Routes>
         
          {/* <Route path="/cross-domain-preview" element={<CrossDomainPreview />} /> */}
          {/* <Route path="/preview-debug" element={<PreviewDebugger />} /> */}
          <Route path="/" element={<Home sendPage={sendPage} />} />
          <Route path="/release/:slug" element={<Details sendPage={sendPage} />} />
          <Route path="/contact/" element={<Contact sendPage={sendPage} />} />
          {/* <Route path="/updates/" element={<Updates sendPage={sendPage} />} /> */}
          <Route path="/services/" element={<Services sendPage={sendPage} />} />          
          <Route path="/about/" element={<About sendPage={sendPage} />} />
          <Route path="/work-for-brands/" element={<WorkForBrands sendPage={sendPage} />} />
          <Route path="*" element={<NotFound sendPage={sendPage} />} />
        </Routes>           
      <Footer />
      </ThemeProvider>
    );
}

export default App;
